module.exports = __webpack_public_path__ + "img/3.2dcf948b.png";